export const ADD_STORE = 'ADD_STORE';
export const UPDATE_STORE = 'UPDATE_STORE';
export const ADD_VIEW_MODE = 'ADD_VIEW_MODE';
export const UPDATE_VIEW_MODE = 'UPDATE_VIEW_MODE';
export const GET_STORE_LIST = 'GET_STORE_LIST';
export const GET_SELECTED_STORE = 'GET_SELECTED_STORE';
export const GET_STORE_LIST_START = 'GET_STORE_LIST_START';
export const GET_STORE_LIST_ERROR = 'GET_STORE_LIST_ERROR';
export const UPDATE_STORE_DATA = 'UPDATE_STORE_DATA';
export const LOAD_STORE_DATA = 'LOAD_STORE_DATA';
export const API_SUCCESS = 'API_SUCCESS';
export const IS_LOGIN = 'IS_LOGIN';

export const IS_STORE_EDIT = 'IS_STORE_EDIT';
export const IS_STORE_CREATE = 'IS_STORE_CREATE';
export const IS_STORE_LIST = 'IS_STORE_LIST';
export const IS_STORE_VIEW = 'IS_STORE_VIEW';
export const GET_STORE_LIST_STOP='GET_STORE_LIST_STOP'